<template>
	<b-card>
		<div class="hidden-print">
			<b-row class="m-2">
				<b-col>
					<multiselect :options="departments" v-model="departmentId" label="name" track-by="id" :multiple="false" :allow-empty="true" :group-select="true" :show-labels="false"  class="multiselect-pricing" :placeholder="$t('promo-to-product.department')"/>
<!--					<select class="custom-select" v-model="departmentId">-->
<!--						<option v-for="(item, i) in departments" :key="i" :value="item.id">{{item.name}}</option>-->
<!--					</select>-->
				</b-col>
				<b-col>
					<date-picker v-model="startDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker v-model="endDate" lang="ru" style="width: 100%" :placeholder="$t('по (время)')" valueType="format" format="DD-MM-YYYY"/>
				</b-col>
			</b-row>
			<b-row class="m-2">
				<b-col>
					<multiselect v-model="currency" :options="options"  class="multiselect-pricing" :placeholder="$t('Валюта')"/>
				</b-col>
				<b-col>
					<select class="custom-select" v-model="contragentId">
						<option v-for="(item, i) in contragentList" :key="i" :value="item.id">{{item.fullName}}</option>
					</select>
				</b-col>
				<b-col cols="1" align="center">
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-3"/>
				</b-col>
			</b-row>
		</div>
		<b-card-body>
			<b-overlay :show="loading" rounded opacity="0.7">
				<b-table :items="items" :fields="columns" striped hover show-empty :busy="loading" class="m-2 mr-2" id="gridContainer" foot-clone>
					<template slot="id" slot-scope="data">
						{{(data.index + 1) }}
					</template>
					<template #foot(id)="data">
						{{""}}
					</template>
					<template #foot(departmentName)="data">
						{{""}}
					</template>
					<template #foot(contragentName)="data">
						{{""}}
					</template>
					<template #foot(contragentPhone)="data">
						{{""}}
					</template>
					<template #foot(regNumber)="data">
						{{""}}
					</template>
					<template #foot(date)="data">
						{{""}}
					</template>
					<template #foot(currency)="data">
						{{"Итого :"}}
					</template>
					<template #foot(credit)="data">
						{{offsInTermEur}}
					</template>
				</b-table>
			</b-overlay>
<!--			<b-row class="m-2">-->
<!--				<b-col v-if="offsInTermEur">-->
<!--					<b>Итого : </b> <span>{{offsInTermEur}}</span>-->
<!--				</b-col>-->
<!--			</b-row>-->
			<b-button v-if="items.length > 0" class="float-right mt-1" @click="excelExport1('gridContainer', 'Отчет Должников')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import DxDataGrid, {DxColumn, DxExport, DxColumnChooser, DxFilterRow, DxSearchPanel, DxLoadPanel} from "devextreme-vue/data-grid";
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import ReportService from "./report.service";
import {BTable, VBTable} from "bootstrap-vue";
import { BOverlay } from 'bootstrap-vue';
import ReferencesService from "../../../services/references.sevice";
import PosService from "@/services/pos.service";

export default {
	name: "Index",
	components: {
		BOverlay,
		Multiselect,
		BTable,
		VBTable
	},
	data() {
		return {
			contragentId:null,
			payload: {
				page: 1,
				limit: 20,
				value: "",
			},
			item:[],
			columns : [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'departmentName', label: this.$t('promo-to-product.department'), class: 'text-center', sortable: true},
				{key: 'contragentName', label: this.$t('Контрагент Имя'), class: 'text-center'},
				{key: 'contragentPhone', label: this.$t('Номер телефона'), class: 'text-center'},
				{key: 'regNumber', label: this.$t('Док. Номер'), class: 'text-center'},
				{key: 'date', label: this.$t('Дата'), sortable: true, class: 'text-center'},
				{key: 'currency', label: this.$t('Валюта'), class: 'text-center'},
				{key: 'credit', label: this.$t('Сумма'), class: 'text-center'},
			],
			expanseTypeId:'',
			currency:"",
			options:['UZS','USD'],
			startDate:"",
			endDate:'',
			departmentId: null,
			departmentIds: null,
			loading:false,
			Why:[],
			items:[],
			departments:[],
			contragentList:[]
		}
	},
	watch: {
	},
	methods: {
		onContentReady(e) {
			e.component.option("loadPanel.enabled", false);
		},
		getDepartments() {
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getItems() {
			if(this.departmentId && this.startDate && this.endDate) {
				this.loading = true
				let data = {
					departmentId:this.departmentId ? this.departmentId.id : null,
					startDate: this.startDate,
					endDate: this.endDate,
					currency: this.currency,
					expanseTypeId: this.expanseTypeId.id,
					contragentId: this.contragentId
				}
				ReportService.getReportItems8(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					this.loading = false
				})
			}
			else {
				this.$vs.notify({
					title: "Выберите Подразделение с периодом",
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			}
		},
		print() {
			window.print();
		},
		listItems(){
			ReferencesService.getSearchExpenses1(this.payload,).then(res => {
				this.Why = res.data.items
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getBirbalo1(id) {
			let data = {
				page: 1,
				limit: 10000,
				categoryId: id
			}
			PosService.getContragentByContractorType(data).then(res => {
				this.contragentList = res.data.items
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					text: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},

		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		excelExport(tableID, filename = '') {

			var downloadLink;

			var dataType = 'text/xls;charset=UTF-8';
			//var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		}
	},
	computed:{
		offsInTermEur() {
			let sum = 0
			this.items.forEach(t => {
				if (t.credit)
					sum += Math.abs(t.credit)
			})
			return sum
		},
	},
	created() {
		this.getDepartments()
		this.getBirbalo1()
		this.listItems()
	}
}
</script>

<style scoped>
@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
}
</style>
